import React from 'react';
import logo from './logo.svg';
import './App.css';
import PageRoutes from './routes/PageRoutes';
import 'bootstrap/dist/css/bootstrap.min.css';

function App() {
  return (
    <PageRoutes />
  );
}

export default App;
